import ProfileReducer from './profile/Profile.reducer';
import JobsReducer from './jobs/jobs.reducer';
import TestsReducer from './tests/Tests.reducer';
import OnboardingPage3Reducer from './Onboarding/Page3/Page3.reducer';
import PreTestCommonReducer from './Onboarding/RightSidebar/preTestCommon.reducer';
import OnboardingReducer from './Onboarding/Onboarding.reducer';
import BasicProfileReducer from './Onboarding/Page2/BasicProfile.reducer';
import ResumeUploadReducer from './Onboarding/Page1/resumeUpload.reducer';
import FinalStepReducer from './Onboarding/Page4/Page4.reducer';
import SkillEditorReducer from './shared/SkillEditor/SkillEditor.reducer';
import InStackDemandSelectorReducer from './shared/InStackDemandSelector/InStackDemandSelector.reducer';
import JobCardReducer from './shared/JobCard/index.reducer';
import HomeReducer from './home/Home.reducer';
import NotificationsReducer from './Notifications/Notifications.reducer';
import { jobInterestReducer } from '../../v3/components/JobInterest/job-interest/job-interest.reducer';
import { countriesReducer } from '../../v3/components/JobInterest/countries/countries.reducers';

const reducers = {
  profile: ProfileReducer,
  jobs: JobsReducer,
  notifications: NotificationsReducer,
  tests: TestsReducer,
  home: HomeReducer,
  workHistory: OnboardingPage3Reducer,
  preTestCommon: PreTestCommonReducer,
  finalStep: FinalStepReducer,
  onboarding: OnboardingReducer,
  basicProfile: BasicProfileReducer,
  resumeUpload: ResumeUploadReducer,
  skillEditor: SkillEditorReducer,
  user_demand_stack_skills: InStackDemandSelectorReducer,
  jobCard: JobCardReducer,
  jobInterest: jobInterestReducer,
  countries: countriesReducer
};

export {
  reducers
};
